<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{noticia.categoria_nome}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

  <div class="gradient-extendido" *ngIf="loaded"></div>

  <div #divNoticia *ngIf="loaded">
    <ion-card *ngIf="noticia.id" class="card-noticia gradient-extendido-recuo">
      <div>
        <img
          [hidden]="playingVideo"
          [src]="noticia.imagemApp | image:'evento'"
        />

        <div *ngIf="playVideo">
          <video-player
            [hidden]="!playingVideo"
            [video]="noticia.videoPrincipal.url"
            [autoPlay]="true"
          >
          </video-player>
        </div>

        <div
          *ngIf="noticia.videoPrincipal.id && !playingVideo"
          class="video-card"
          (click)="play();"
        >
          <ion-icon
            *ngIf="!playVideo"
            class="play"
            name="play-outline"
          ></ion-icon>
          <img
            class="play gif"
            *ngIf="playVideo"
            src="../../assets/imgs/dots_gif.gif"
          />
        </div>
      </div>
    </ion-card>

    <ion-card-content *ngIf="noticia.id">
      <ion-card-title>
        <ion-item>
          <ion-label>
            <p class="titulo ellipse two-lines">{{noticia.titulo}}</p>
            <p class="subtitulo">{{noticia.subtitulo}}</p>
          </ion-label>

          <ion-note slot="end" *ngIf="!userProvider.hasConfig(208)">
            <i
              class="fas fa-share-alt icon-card"
              style="font-size: 21px !important"
              (click)="share()"
            ></i>
          </ion-note>
        </ion-item>
      </ion-card-title>
    </ion-card-content>

    <audio-player
      *ngIf="noticia.id && noticia.audioPrincipal.id"
      [audioUrl]="noticia.audioPrincipal.url"
      [nome]="noticia.audioPrincipal.nome"
      [smallVersion]="true"
      [image]="noticia.imagemApp"
    ></audio-player>

    <p
      class="conteudo"
      *ngIf="noticia.id && noticia.conteudo"
      [innerHTML]="noticia.conteudo | safeHtml: 'html'"
    ></p>

    <div *ngIf="noticia.id && noticia.links.length && hasPrincipalLink()" class="conteudo-add">
      <div class="gradient-extendido-div">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fas fa-unlink div-icon" style="margin-top: 2px"></i>
          </ion-note>

          <ion-label class="color-title">
            {{'Links Úteis' | translate}}
          </ion-label>
        </div>
      </div>

      <ion-grid>
        <ion-row
          style="padding-left: 10px"
          *ngFor="let link of noticia.links;"
          (click)="openLink(link);"
        >
          <ion-col
            class="conteudo-list remove-border"
            *ngIf="link.principal && link.principal == '1'"
          >
            <ion-item>
              <ion-note slot="start">
                <i class="fas fa-globe-americas icon-list"></i>
              </ion-note>

              <ion-label>
                <p class="conteudo-mensagem bold-1" style="margin: 0px">
                  {{link.nome}}
                </p>
              </ion-label>

              <ion-note slot="end">
                <ion-icon
                  name="arrow-forward-outline"
                  class="icon-list"
                ></ion-icon>
              </ion-note>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div
      *ngIf="noticia.id && (noticia.videos.length || noticia.links.length || noticia.audios.length)"
      class="conteudo-add"
    >
      <div class="gradient-extendido-div">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fas fa-unlink div-icon" style="margin-top: 2px"></i>
          </ion-note>

          <ion-label class="color-title">
            {{'Conteúdo Adicional' | translate}}
          </ion-label>
        </div>
      </div>

      <ion-list lines="none">
        <ion-item
          *ngFor="let item of midiaDisponivel"
          (click)="item.action()"
          detail="false"
        >
          <ion-note slot="start">
            <i [class]="item.icon" style="font-size: 18px !important" class="icon-list"></i>
          </ion-note>

          <ion-label>{{ item.label | translate }}</ion-label>

          <ion-note slot="end" color="medium">
            {{ noticia[item.key].length }}
          </ion-note>
        </ion-item>
      </ion-list>
    </div>
  </div>
</ion-content>
